module.exports = __webpack_public_path__ + "static/DY1-c84fbd2cc8a1b4006657658a91ccf648.jpg";